module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin"
    }
  }, [_vm._v("Admin")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/publisher"
    }
  }, [_vm._v("Publishers")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Publisher Domains")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "add-domain-button float-right"
  }, [_c('router-link', {
    attrs: {
      "to": ("" + ('/admin/publisher/'  + _vm.publishersUuid +  '/' + _vm.publishersId + '/domain/add/'))
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus"
  })])], 1)], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "cart-items width-custom width-100 pull-left pl-60 pr-30 pb-0 pt-0 container-fluid"
  }, [_c('li', {
    staticClass: "cart-items-labels visible-lg-block visible-md-block row"
  }, [_c('span', {
    staticClass: "col-md-6 text-muted small"
  }, [_vm._v("Domains")])]), _vm._v(" "), _vm._l((_vm.publishers), function(option) {
    return _c('li', {
      staticClass: "row"
    }, [_c('span', {
      staticClass: "cart-image col-xs-12 col-sm-12 col-md-2"
    }, [_c('router-link', {
      staticClass: "h5",
      attrs: {
        "to": ("" + ('/admin/publisher/' + option.publisher.uuid + '/domain/edit/' + option.id))
      }
    }, [_c('avatar', {
      attrs: {
        "username": option.name,
        "size": 50,
        "color": "#fff"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "cart-item-right col-md-10 col-xs-12 col-sm-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('span', {
      staticClass: "cart-description col-xs-12 col-md-5"
    }, [_c('router-link', {
      staticClass: "h5",
      attrs: {
        "to": ("" + ('/admin/publisher/' + option.publisher.uuid + '/domain/edit/' + option.id))
      }
    }, [_vm._v(_vm._s(("" + (option.name))))])], 1), _vm._v(" "), _c('span', {
      staticClass: "col-md-5 col-sm-12 text-right"
    }, [_c('router-link', {
      staticClass: "hoverColor",
      attrs: {
        "to": ("" + ('/admin/publisher/' + option.publisher.uuid + '/domain/edit/' + option.id))
      }
    }, [_c('span', {
      staticClass: "ti-pencil-alt pull-right mt-5 ml-10"
    })])], 1)])])])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71877f11","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/PublisherInfo.vue
// module id = 696
// module chunks = 2